import {
  BaseError,
  createErrorBuilder,
} from '@wix/public-editor-platform-errors';

export enum EditorPlatformEditActionsErrorCode {
  EditActionPanelUrlFormatIsNotSupported = 'Edit action panel URL format is not supported',
  EditActionExecutionTypeIsNotSupported = 'Edit action execution type is not supported',
  EditActionExecutionIsMissing = 'Edit action execution is missing',
  EditActionExecutionDoesNotMatchCustomActionFormat = 'Edit action execution does not match custom action format',
  EditActionAppDataIsMissing = 'Edit action app data is missing',
  EditActionUnsupportedActionType = 'Edit action unsupported action type',
  EditActionPanelContentMissing = 'Edit action panel content is missing. The panel might not be loaded because of an error',
  EditActionPanelUrlIsMissing = 'Edit action panel URL is missing',
}

class EditorPlatformEditActionsError extends BaseError<EditorPlatformEditActionsErrorCode> {
  constructor(message: string, code: EditorPlatformEditActionsErrorCode) {
    super(message, code, 'Editor Platform Edit Actions Error');
  }

  withActionName(actionName: string) {
    this.state.actionName = actionName;
    return this;
  }
}

export const createEditorPlatformEditActionsError = createErrorBuilder<
  EditorPlatformEditActionsErrorCode,
  EditorPlatformEditActionsError
>(EditorPlatformEditActionsError);
